export default "__VITE_PUBLIC_ASSET__99311225__"